import { render, staticRenderFns } from "./EnterpriseEnquireForm.vue?vue&type=template&id=c130a6d2&scoped=true"
import script from "./EnterpriseEnquireForm.vue?vue&type=script&lang=ts"
export * from "./EnterpriseEnquireForm.vue?vue&type=script&lang=ts"
import style0 from "./EnterpriseEnquireForm.vue?vue&type=style&index=0&id=c130a6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c130a6d2",
  null
  
)

export default component.exports